export default __webpack_public_path__ + "static/media/Icon awesome-medal.6acd63a9.svg";